import type {
  ParsedBooleanFilter,
  ParsedDateFilter,
} from '@/lib/utils/compact-filters/transformCompactFilters';
import type { DateOperator } from '@/lib/zod-schemas/common/operators';

export const getArrayValue = <T>(
  parsed: { value: T | T[] | null } | undefined,
): T[] | undefined => {
  if (parsed?.value == null) return undefined;
  const arr = Array.isArray(parsed.value) ? parsed.value : undefined;
  if (!arr || arr.length === 0) return undefined;
  return arr;
};

export const getBooleanValue = (parsed: ParsedBooleanFilter | undefined): boolean | undefined => {
  if (!parsed) return undefined;
  if (parsed.operator === 'eq') {
    return parsed.value ?? false;
  }
  return parsed.value === null ? false : parsed.value;
};

export const getDateFilterValue = (
  parsed: { value: string[] | null; operator: DateOperator } | undefined,
): ParsedDateFilter | undefined => {
  if (!parsed) return undefined;
  if (parsed.operator === 'null' || parsed.operator === 'notnull') {
    return {
      value: [],
      operator: parsed.operator,
    };
  }
  if (parsed.value == null) return undefined;
  return {
    value: parsed.value,
    operator: parsed.operator,
  };
};
